<div class="banner-avatar ml-8">
  <app-community-member-avatar [avatar]="member.avatar" display="large" [height]=170 [width]=110></app-community-member-avatar>
</div>
